//@flow
import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import isEqual from 'lodash/isEqual';

type Props = {
  data: string,
  resetFn: Function,
  filterFn: Function,
};

const defaultState = { searchTerm: '' };

class SearchTrek extends Component<Props> {
  state = defaultState;

  filterBySearchTerm = () => this.props.filterFn(this.state.searchTerm);

  handleChange = e => this.setState({ searchTerm: e.target.value });

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.filterBySearchTerm();
    }
  };

  handleReset = () => {
    this.props.resetFn();
    this.setState({ ...defaultState });
  };

  componentDidUpdate(prevProps) {
    const { data } = this.props;

    if (!isEqual(data, prevProps.data)) {
      if (!isEqual(data, this.state.searchTerm)) {
        this.setState({ ...defaultState });
      }
    }
  }

  render() {
    const { data } = this.props;
    const { searchTerm } = this.state;
    return (
      <div className="widget widget-search">
        <InputGroup>
          <Input
            type="text"
            value={searchTerm}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPress}
            placeholder="Search Trek"
          />
          <InputGroupAddon addonType="append">
            <span className="input-group-text">
              <i
                onClick={data ? this.handleReset : this.filterBySearchTerm}
                className={`icon ${data ? 'icon-hg-cross' : 'icon-hg-search'}`}
              />
            </span>
          </InputGroupAddon>
        </InputGroup>
      </div>
    );
  }
}

export default SearchTrek;



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekFilters/SearchTrek.jsx